import type { Page } from '../../types';

const civilProsecutionsFraud: Page[] = [
  {
    pageType: 'question',
    title: 'Civil prosecutions for fraud',
    name: 'civil-prosecutions-fraud-declare',
    questions: [
      {
        questionType: 'radio',
        title: 'Do you have any instances of civil prosecutions for fraud to declare?',
        name: 'prosecutions_civil_fraud_declare',
        options: ['Yes', 'No'],
        rules: { required: true },
      },
    ],
  },
  {
    pageType: 'question',
    title: 'Civil prosecutions for fraud',
    name: 'civil-prosecutions-fraud',
    type: 'nilreturn',
    fastToggle: true,
    disabled: [
      {
        field: 'prosecutions_civil_fraud_declare',
        condition: 'equals',
        value: 'No',
      },
    ],
    questions: [
      {
        questionType: 'instanceInput',
        title: 'How many prosecutions were referred?',
        name: 'prosecutions_civil_fraud_referral',
        hint: 'Total number of instances',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'instanceInput',
        title: 'How many prosecutions proceeded to charge?',
        name: 'prosecutions_civil_fraud_proceed_charged',
        hint: 'Total number of instances',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'instanceInput',
        title: 'How many prosecutions were successful?',
        name: 'prosecutions_civil_fraud_successful',
        hint: 'Total number of instances',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textarea',
        title: 'Comments',
        hideOptionalLabel: true,
        name: 'prosecutions_civil_fraud_comments',
        hint: 'Please ensure you do not include any personal or sensitive information',
        rules: {
          required: false,
        },
      },
    ],
  },
];
export default civilProsecutionsFraud;




